import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    private companyId: number | null = null

    open(companyId: number): void {
        this.companyId = companyId
        this.element.dispatchEvent(new CustomEvent('modal:open'))
    }

    async confirm(): Promise<void> {
        if (!this.companyId) {
            return
        }

        const response = await fetch(`/api/buyer/companies/${this.companyId}`, {
            method: 'DELETE',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
        })

        const data = await response.json()

        if (!response.ok) {
            window.dispatchEvent(new CustomEvent('alert:show', {
                detail: { message: data.error ?? 'Ошибка при удалении компании', variant: 'error' },
            }))

            return
        }

        window.location.reload()
    }
}
